import {remCalc} from '_themeUtils'

const NewsletterModalStep2 = {
    NewsletterModal_step_2: {
        baseStyle: () => ({
            form: {
                h: '100%',
                opacity: '1',
                transition: 'opacity 0.2s ease-in-out',
            },
            titleWrapper: {
                textStyle: {base: 'displayXs', md: 'displaySm'},
                fontWeight: 400,
                mt: 'spacing.5',
                mb: 'spacing.10',
            },
            inputsWrapper: {
                textStyle: 'paragraphSm',
                borderBottomWidth: '1px',
                fontWeight: 400,
                gap: 'spacing.4',
            },
            description: {
                textStyle: 'paragraphSm',
                color: 'color.text.grey.700',
                lineHeight: remCalc(21),
                fontWeight: 300,
                mb: 'spacing.4',
                mt: 'spacing.2',
            },
            gridPreferences: {
                w: '100%',
                pb: 'spacing.2',
                gap: 'spacing.4',
                templateColumns: 'repeat(3, 1fr)',
            },
            privacy_policy_2: {
                textStyle: 'paragraphSm',
                color: 'color.text.grey.700',
                fontWeight: 300,
                lineHeight: remCalc(21),

                pb: {base: 'spacing.2', md: 'unset'},
            },
            footerWrapper: {
                p: {base: `${remCalc(24)} ${remCalc(20)} ${remCalc(24)} ${remCalc(20)}`, md: `${remCalc(24)} ${remCalc(24)} ${remCalc(40)} ${remCalc(56)}`},
                m: {base: `auto -${remCalc(16)} 0 -${remCalc(16)}`, md: `auto -${remCalc(24)} 0 -${remCalc(56)}`},
                position: 'sticky',
                bottom: '0',
                zIndex: '1',
                flexDirection: 'column',
                alignItems: 'center',
                bg: '#f9f9f9',
            },
            button: {
                alignSelf: 'center',
                w: '100%',
                textTransform: 'uppercase',
                letterSpacing: remCalc(3),
                h: remCalc(54),
            },
            footerCopyrightMessage: {
                textStyle: 'paragraphXs',
                pt: 'spacing.4',
                color: 'color.text.grey.700',
                fontWeight: 400,
                sx: {
                    '.cc-privacy-link': {
                        textStyle: 'paragraphXs',
                        textDecoration: 'underline',
                        lineHeight: remCalc(1),
                        _hover: {
                            color: 'color.text.black',
                            textDecoration: 'underline',
                        },
                    },
                },
            },
        }),
        variants: {
            mobile: {
                inputsWrapper: {
                    flexDirection: 'column',
                },
            },
        },
    },
}

export default NewsletterModalStep2
